/*
 * 拉取文件的入口
 *
 */
import config from '@/constants/config';

import token from '@/utils/token';
import json2param from '@/jquery-plugin/json2param';

import cookie from '@/utils/cookie.js';
import cancelManager from './middlewares/cancel-manager';
import { isInIframe } from '@/utils/index';
import _ from 'lodash';
import {
  handleErrResponse, handleTimeoutReport, MiddlewareModel,
  RequestData, RequestMethod, RequestOptions, useSendBeacon, handleRequestLoading,
  MiddlewareSyncModel, handleGetCacheSync, handleSetCacheSync, handleUpdateCache,
} from './middlewares/cgi';
import { ExecuteResult } from '@/model/common';
import message from '@/utils/message';


export interface FetchOptions {
  method: RequestMethod;

  data: RequestData;

  key?: string;

  contentType?: string | boolean; // contentType

  // 超时配置
  timeout?: number;
  ignoreTimeout?: boolean;

  // 使用seadBeacon发送请求
  useSendBeacon?: boolean;

  // 缓存相关
  cache?: any;
  isCache?: boolean;
  cacheMaxAge?: number;
  isCancel?: boolean;

  processData?: boolean;

  // 发起请求时页面全局loading
  loadingTip?: string;

  headers?: Record<string, any>;
}

/*
 * 给fetch添加中间件（主要是为了处理所有公共发起的cgi）
 * @param opts {object}
 * @param opts.fetch {object} fetch的url,必须是支持链式的
 * @param opts.data {obejct}
 * @param opts.middleware {Array} 根据数组从0至N添加组件（每个组件是函数哦）
 * @return fetch
 */
function applyMiddleware<T>(config: {
  fetch: (requestConfig: RequestOptions) => Promise<any>;
  data: RequestOptions;
  beforeMiddleware?: MiddlewareModel[];
  afterMiddleware?: MiddlewareModel[];
  beforeMiddlewareSync?: MiddlewareSyncModel[];
  afterMiddlewareSync?: MiddlewareSyncModel[];
}) {
  const fetch = config.fetch;
  let data = config.data || '';
  const afterMiddleware = config.afterMiddleware || [];
  const beforeMiddleware = config.beforeMiddleware || [];
  const afterMiddlewareSync = config.afterMiddlewareSync || [];
  const beforeMiddlewareSync = config.beforeMiddlewareSync || [];

  beforeMiddlewareSync.forEach((middleware) => {
    data = middleware(data);
  });

  let promise = Promise.resolve(data as any);

  for (let i = 0, len = beforeMiddleware.length; i < len; i++) {
    if (beforeMiddleware[i]) {
      const [resolve, reject] = beforeMiddleware[i](data);
      promise = promise.then(resolve, reject);
    }
  }

  promise = promise.then(fetch);

  afterMiddlewareSync.forEach((middleware) => {
    data = middleware(data, promise);
  });

  for (let i = 0, len = afterMiddleware.length; i < len; i++) {
    if (afterMiddleware[i]) {
      const [resolve, reject] = afterMiddleware[i](data, promise);
      promise = promise.then(resolve, reject);
    }
  }

  return promise as Promise<ExecuteResult<T>>;
};

/*
 * 下载文件
 * @param url {string} 请求的url
 * @param data {object} 下载请求的参数
 * @return void 没有返回
 */
let downloadIndex = 0;
const download = (url: string, data: any) => {
  url = url || '';
  data = data || {};
  const id = `downloadIframe_${downloadIndex++}`;
  let iframe = '';
  const $body = $('body');
  const downloadWaitTime = 40000;

  if (!url) {
    return false;
  }

  if (url.indexOf('?') > -1) {
    url += '&';
  } else {
    url += '?';
  }

  url += json2param.stringify(data);
  iframe = `<iframe id="${id}" src="//${config.SITE.domain}${url}" frameborder=0 scrolling="no" style="display:none;width:0;height:0;" width="0" height="0"></iframe>`;

  $body.append(iframe);
  setTimeout(() => {
    const $id = $(`#${id}`);
    if ($id.length > 0) {
      $id.remove();
    }
  }, downloadWaitTime);
};

/*
 * 获取接口URL(自己服务path的url)
 * @param mod {string} api模块名字
 * @param act {string} api的act名字
 * @return {string} api的完整url
 */
export const getApiUrl = (mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  return `${config.SITE.apiUrl}?mod=${mod}&act=${act}`;
};
/*
 * 获取接口URL(自己服务path的url)
 * @param mod {string} api模块名字
 * @param act {string} api的act名字
 * @return {string} api的完整url
 */

export const getAgpApiUrl = (mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  return `${config.SITE.smbUrl + mod}/${act}`;
};

/**
 * 获取 agp 下 agms 的url，格式: /agp/agms/${mod}/${act}
 */
export const getAgpAgmsApiUrlNew = (mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  return `${config.SITE.smbUrl}agms/${mod}/${act}`;
};


/**
 * 获取 agp 下 agms 的url，格式: /agp/agms/v1/${mod}/${act}
 */
export const getAgpAgmsApiUrl = (mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  return `${config.SITE.smbUrl}agms/v1/${mod}/${act}`;
};

/**
 * 获取 policy 下 gw/identity_verify_api/ 的url，格式: /policy/gw/identity_verify_api/v1/${mod}/${act}
 */
export const getPolicyGwIdentityApiUrl = (mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  return `${config.SITE.policyUrl}gw/identity_verify_api/v1/${mod}/${act}`;
};

/**
 * 获取 agp 下 tap 的url，格式: /tap/v1/${mod}/${act}
 */
export const getTapUrl = (mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  return `/tap/v1/${mod}/${act}`;
};

/**
 * 获取 bm v2 的url，格式: /agp/bm_service/${mod}/${act}
 * /agp/bm_service/* 转发到 /bm/v2/*
 */
export const getBmUrl = (mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  return `/agp/bm_service/${mod}/${act}`;
};

/*
 * 获取接口URL(自己服务path的url)
 * @param mod {string} api模块名字
 * @param act {string} api的act名字
 * @return {string} api的完整url
 */
export const getSmbUrl = (pre: string, mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  if (!act) {
    return `${`/${pre}/${mod}`}`;
  }
  return `${`/${pre}/${mod}`}/${act}`;
};

export const getAgsApiUrl = (...opt: any[]) => {
  let url = '/ags';
  opt
    && opt.map((v) => {
      if (v !== '') return (url += `/${v}`);
    });
  return url;
};

export const getSsoCgiUrl = (...opt: any[]) => {
  let url = '/sso_cgi';
  opt
    // eslint-disable-next-line array-callback-return
    && opt.map((v) => {
      if (v !== '') return (url += `/${v}`);
    });
  return url;
};

export const getUserInfoApiUrl = () => `${config.SITE.adpUrl}get_qq_user_info`;
/*
 * 获取接口URL(atlas服务path的url)
 * @param mod {string} api模块名字
 * @param act {string} api的act名字
 * @return {string} api的完整url
 */
export const getAtlasApiUrl = (mod: string, act: string) => {
  mod = mod || '';
  act = act || '';

  if (!mod && !act) {
    return '';
  }
  return `${config.SITE.ecApiUrl}?mod=${mod}&act=${act}`;
};

/*
 * 发起请求
 * @param url {string} 请求的url
 * @param params {object}
 * @param params.method {string} 'GET/POST' 默认是GET
 * @param params.data {object} 参数
 * @param isShowError {bool} 是否显示错误信息*某些情况下，调用方需要自己决定在哪里显示错误信息*
 * @param addAdpFlag {bool} 当来自投放端时是否增加_advertiser_id标识
 * @return smb_fetch 用于新版服务商系统的fetch
 */

export function smb_fetch<T>(url: string, params: FetchOptions, isShowError = true, needAgencyUid = true, addAdpFlag = true): Promise<ExecuteResult<T>> {
  const { data: paramsData, method: paramsMethod, ...ortherParams } = params;

  const bm_id = cookie.get('bm_id');
  const agency_uid = cookie.get('agency_uid');
  url = url || '';
  let method: RequestMethod = paramsMethod;
  let data = paramsData || {};

  if (needAgencyUid) {
    data = bm_id || agency_uid ? Object.assign({ bm_id, agency_uid }, paramsData) : paramsData || {};
    if (!data.bm_id) {
      data.bm_id = 0;
    }
    if (!data.agency_uid) {
      data.agency_uid = 0;
    }
  }

  if (data.bm_id == 0 && data.agency_uid == 0 && url == '/agp/account/get_agency') {
    return Promise.resolve({} as ExecuteResult<T>);
  }

  // 投放端内嵌时，不进行权限校验
  if (isInIframe() && _.some(config.SITE.skipAuthPath, (rule) => rule.test(location.href)) && addAdpFlag) {
    data = {
      ...data,
      _advertiser_id: data.account_id || data.advertiser_id || data.uid,
      agency_uid: 0,
      bm_id: 0,
    };
  }

  // 销售老接口特判
  if (_.isArray(paramsData)) {
    data = paramsData;
  }

  if (!url) {
    return Promise.reject(false);
  }

  // 过滤下method
  method = method.toUpperCase() as RequestMethod;
  if (method === 'GET') {
    data.g_tk = token.getACSRFToken();
  } else {
    if (url.indexOf('?') === -1) {
      url += `?g_tk=${token.getACSRFToken()}`;
    } else {
      url += `&g_tk=${token.getACSRFToken()}`;
    }
  }

  if (method === 'GET') {
    // GET请求过滤掉空字符
    const filterData: Record<string, any> = {};
    Object.keys(data).forEach((key) => {
      if (data[key] !== '') {
        filterData[key] = data[key];
      }
    });
    data = filterData;
  }

  const ajaxOpts = {
    url,
    type: method,
    ...ortherParams,
    contentType: params.contentType,
    headers: params.headers,
    key: params.key,
    timeout: params.timeout,
    data: params.contentType === 'application/json' ? JSON.stringify(data) : data,
  };

  if (params.processData === false && params.contentType === false) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    ajaxOpts.data = formData as any;
  }

  const requestConfig: RequestOptions = {
    ...ajaxOpts,
    isCache: params.isCache,
    cacheMaxAge: params.cacheMaxAge,
    isCancel: params.isCancel,
    startTime: +new Date(),
    ignoreTimeout: params.ignoreTimeout,
    isShowError,
    useSendBeacon: params.useSendBeacon || false,
    processData: params.processData || false,
  };

  return applyMiddleware({
    fetch: (requestConfig: RequestOptions): Promise<any> => {
      if (requestConfig.cache) {
        return requestConfig.cache;
      }
      if (requestConfig.useSendBeacon) {
        return Promise.resolve({ code: 0 } as ExecuteResult<T>);
      }

      const xhr = $.ajax(ajaxOpts);
      // 自定义取消token以支持外部通过cancelManager取消请求
      if (requestConfig.cancelToken) {
        cancelManager.set(requestConfig.cancelToken, xhr);
      }
      // 请求url相同时取消前一个请求
      if (requestConfig.isCancel) {
        if (cancelManager.has(requestConfig.url)) {
          // 取消前一个请求
          cancelManager.abort(requestConfig.url);
        }
        cancelManager.set(requestConfig.url, xhr);
      }

      return xhr;
    },
    data: requestConfig,
    beforeMiddlewareSync: [
      handleGetCacheSync,
    ],
    afterMiddlewareSync: [
      handleSetCacheSync,
    ],
    afterMiddleware: [
      handleUpdateCache,
      handleErrResponse,
      handleTimeoutReport,
    ],
    beforeMiddleware: [
      useSendBeacon,
      handleRequestLoading,
    ],
  });
};

interface FetchWhenCloseOptions {
  data?: Record<string, any>;
  headers?: Record<string, any>;
}

const browserSupportsKeepalive = 'keepalive' in new Request('');
export const fetchWhenClose = (url: string, params?: FetchWhenCloseOptions) => {
  const { data = {}, headers = {} } = params || {};
  if (browserSupportsKeepalive) {
    try {
      fetch(url, {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        body: JSON.stringify(data),
        credentials: 'include',
      });
    } catch (e) { }
  } else { // firefox暂不支持keepalive，采用sendBeacon兼容
    const blob = new Blob([JSON.stringify(data)], {
      type: 'application/json',
    });
    navigator.sendBeacon(url, blob);
  }
};

/**
 * 将BASE64编码转换为PDF文件并下载
 * @param base64String - BASE64编码的PDF数据
 * @param fileName - 下载文件名
 */
export const downloadPdfFromBase64 = (base64String: string, fileName = 'document.pdf') => {
  try {
    // 1. 将BASE64字符串解码为二进制数据
    const byteCharacters = atob(base64String);

    // 2. 将字符转换为字节数组
    const byteArrays = [];
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    // 3. 创建Uint8Array
    const byteArray = new Uint8Array(byteArrays);

    // 4. 创建Blob对象
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // 5. 创建下载链接
    const fileUrl = URL.createObjectURL(blob);
    const aElement = document.createElement('a');
    aElement.download = fileName;
    aElement.href = fileUrl;

    // 6. 触发下载
    document.body.appendChild(aElement);
    aElement.click();
    document.body.removeChild(aElement);

    // 7. 清理URL对象
    URL.revokeObjectURL(fileUrl);

    message.success(`${fileName}下载成功`);
  } catch (error) {
    console.error('PDF下载失败:', error);
    message.error(`${fileName}下载失败`);
  }
};

export default {
  smb_fetch,
  getApiUrl,
  getAgpApiUrl,
  getSmbUrl,
  getAtlasApiUrl,
  getUserInfoApiUrl,
  fetchWhenClose,
};
